import { BankFieldSetLabel } from "client/domain/FormBuilder/BankInformation/BankConnector";
import { CountryList } from "client/lib/apt-merchant";
import type { UserStateResponse } from "client/types";
import { apiClient } from "client/utils";

export type GetPlaidTokenResponse = {
  linkToken: string;
  error?: { plaidError: string };
};

type PlaidInfoResponse = UserStateResponse & {
  error?: { plaidError: string };
};

export type UpdatePlaidInfoRequest = {
  token: string;
  id: string;
  bankAccountName: string;
  registeredCountry?: CountryList;
  bankName: string;
  bankLabel: BankFieldSetLabel;
  setBankFormComplete: boolean;
};

export const getPlaidLinkToken = ({
  storeName,
}: {
  storeName?: string;
}): Promise<GetPlaidTokenResponse> =>
  apiClient<GetPlaidTokenResponse>("/api/plaid/create-link-token", {
    data: {
      storeName,
    },
  });

export const updatePlaidInfo = (
  data: UpdatePlaidInfoRequest
): Promise<PlaidInfoResponse> =>
  apiClient<PlaidInfoResponse>("/api/plaid/update-bank-info", {
    data,
  });
